import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class ProntuariosService {
    constructor(
        private apiService: ApiService
    ) {}
        
    get(id): Observable<any> {
        let url : string = `/prontuarios/${id}`
        return this.apiService.get(url)
    }
    
    getAll(dadosFiltro?): Observable<any> {
        let url : string = `/prontuarios`
        return this.apiService.get(url, dadosFiltro)
    }
    
    restore(id) : Observable<any> {
        return this.apiService.get('/prontuarios/reativar/'+id)
    }
    
    post(form) : Observable<any> {
        return this.apiService.post('/prontuarios', form)
    }
    
    put(id: string, form) : Observable<any> {
        form._method='PUT'
        return this.apiService.post('/prontuarios/'+id, form)
    }
    
    delete(id) {
        return this.apiService.delete('/prontuarios/'+id)
    }
}